import script from "./CommunicationSources.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunicationSources.vue?vue&type=script&setup=true&lang=js"

import "./CommunicationSources.vue?vue&type=style&index=0&id=8141d200&lang=css"

const __exports__ = script;

export default __exports__